export const styles = {
    '.marker-cluster,.marker-custom': {
        backgroundClip: 'padding-box',
        borderRadius: '100%',
    },

    '.marker-cluster div,.marker-custom div': {
        width: 'calc(100% - 4px)',
        height: 'calc(100% - 4px)',
        marginLeft: 5,
        marginTop: 5,
        textAlign: 'center',
        borderRadius: '100%',
        fontSize: 12,
    },

    '.marker-cluster.default > div': {
        display: 'flex',
        marginTop: 2,
        alignItems: 'center',
        marginLeft: 2,
        justifyContent: 'center',
    },
};
